export enum ResponseCode {
    SUCCESS = 0,
    TOKEN_ERROR = 10000,
    TOKEN_EXPIRE = 20005,
}